import slug from 'slug'
import { meilisearchMasterClient } from './client'

export function prefixIndexId(id: string) {
  return process.env.NEXT_PUBLIC_GIT_COMMIT_REF
    ? `preview-${slug(process.env.NEXT_PUBLIC_GIT_COMMIT_REF!)}-${id}`
    : id
}

export function cleanupPreviewIndexes() {
  return async function cleanupPreviewIndexesPipeline() {
    if (
      process.env.NEXT_PUBLIC_ENVIRONMENT_NAME !== 'staging' ||
      !meilisearchMasterClient
    ) {
      // this only needs to be done on staging because that's
      // the meilisearch instance we use for staging
      return
    }
    console.info('ETL: Clean up preview indexes')

    // just pick the first 500 indexes
    // technically there should be pagination here but I would not expect to have _that_ many indexes usually
    // also it will clean up the next batch next time it runs.
    const indexes = await meilisearchMasterClient.getIndexes({ limit: 500 })

    for (const index of indexes.results) {
      // clean up only preview indexes
      if (!index.uid.startsWith('preview-')) continue

      // clean up all indexes that have not been touched in the last 5 days
      const FIVE_DAYS_IN_MS = 1000 * 60 * 60 * 24 * 5
      if (
        index.updatedAt &&
        index.updatedAt.getTime() < Date.now() - FIVE_DAYS_IN_MS
      ) {
        console.info('delete index', index.uid)
        await index.delete()
      }
    }
  }
}
